import React from 'react';
import { Typography } from '@ghq-abi/design-system-v2';

import type { TableColumn } from '../types';

import { TableHeader } from './TableHeader';

interface EmptyTableProps<T> {
  columns: TableColumn<T>[];
  message: string;
  toolbar?: React.ReactNode;
}

export const EmptyTable = <T,>({
  columns,
  message,
  toolbar
}: EmptyTableProps<T>) => (
  <div className="w-full border border-[#EEEFF2] rounded-lg overflow-hidden">
    {toolbar}
    <TableHeader columns={columns} />
    <div className="bg-white p-8 text-center border-b border-l border-r border-[#EEEFF2]">
      <Typography variant="body-sm-regular" color="default">
        {message}
      </Typography>
    </div>
  </div>
);
